// ============================================================================
// PENOW — Configuration centrale du site (facilement modifiable)
// ============================================================================
// PENOW est une PLATEFORME DE MISE EN RELATION (apporteur d'affaires).
// Nous ne réalisons pas les travaux nous-mêmes : nous connectons les clients
// avec des professionnels partenaires qualifiés du bâtiment.
// ============================================================================

export const COMPANY = {
  name: "PENOW",
  tagline: "Mise en relation avec des professionnels qualifiés du bâtiment",
  baseline: "Votre projet, entre les meilleures mains.",
  role: "Plateforme de mise en relation · Apporteur d'affaires",
  logoUrl:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_penow-renovation/artifacts/ravaih29_Logo%20entreprise%20%282%29.png",
  // Coordonnées PENOW
  phone: "06 88 21 39 71",
  phoneHref: "tel:+33688213971",
  email: "peneaujulien@icloud.com",
  address: "37230 Fondettes",
  city: "Fondettes (37)",
  zone: "Région Centre-Val de Loire — particulièrement l'Indre-et-Loire (37)",
  yearsExperience: 15,
  siret: "988 235 263 00015",
  socials: {
    instagram: "#",
    facebook: "#",
    linkedin: "#",
  },
};

// ---------------------------------------------------------------------------
// DISCLAIMER — utilisé sur les pages principales
// ---------------------------------------------------------------------------
export const INTERMEDIARY_NOTICE =
  "PENOW met en relation particuliers et professionnels qualifiés du bâtiment. Nous ne réalisons pas les travaux nous-mêmes.";

// ---------------------------------------------------------------------------
// OFFRE SAISONNIÈRE
// ---------------------------------------------------------------------------
export const SEASONAL_OFFER = {
  season: "Hiver 2025 — Décembre",
  headline: "Préparez votre habitat pour l'hiver",
  intro:
    "Les priorités du moment pour un intérieur confortable, sain et économe — confiées à nos professionnels partenaires.",
  items: [
    {
      key: "isolation",
      title: "Isolation avant l'hiver",
      subtitle: "Combles, murs, planchers",
      description:
        "Jusqu'à 30% d'économies d'énergie. Éligible aux aides de l'État grâce à nos partenaires certifiés RGE.",
    },
    {
      key: "renovation-interieure",
      title: "Rénovation intérieure",
      subtitle: "Peinture, sols, cloisons",
      description:
        "Idéale en saison froide : chantiers à l'abri des intempéries, réalisés par nos partenaires.",
    },
    {
      key: "climatisation",
      title: "Climatisation réversible",
      subtitle: "Installation & mise en service",
      description:
        "Chauffage en hiver, fraîcheur en été. Confort thermique toute l'année, installé par nos partenaires spécialisés.",
    },
  ],
};

// ---------------------------------------------------------------------------
// SERVICES — chaque description décrit ce que le professionnel partenaire fait
// ---------------------------------------------------------------------------
export const SERVICES = [
  {
    slug: "renovation-generale",
    title: "Rénovation générale",
    short: "Intérieur & extérieur",
    description:
      "Nos partenaires prennent en charge votre projet, de la conception à la livraison, en coordonnant tous les corps de métier nécessaires.",
    features: ["Un interlocuteur dédié", "Coordination tous corps de métier", "Suivi de chantier partenaire"],
    featured: true,
  },
  {
    slug: "climatisation",
    title: "Climatisation & PAC",
    short: "Installation & mise en service",
    description:
      "Pompes à chaleur, climatisation réversible : nos professionnels partenaires proposent des solutions performantes, silencieuses et éligibles aux aides de l'État.",
    features: ["Partenaires certifiés RGE QualiPAC", "Aides d'État mobilisées (MaPrimeRénov', CEE)", "Marques premium (LG, Daikin, Mitsubishi)"],
    featured: true,
  },
  {
    slug: "facade",
    title: "Rénovation de façade",
    short: "Nettoyage & ravalement",
    description:
      "Nettoyage haute pression, hydrofuge, enduit, peinture — assurés par des façadiers partenaires expérimentés.",
    features: ["Diagnostic gratuit", "Traitement anti-mousse", "Finitions sur mesure"],
  },
  {
    slug: "toiture",
    title: "Nettoyage & rénovation toiture",
    short: "Démoussage & étanchéité",
    description:
      "Traitement complet des toitures par nos couvreurs partenaires : démoussage, hydrofuge, remplacement de tuiles, étanchéité.",
    features: ["Sécurité chantier certifiée", "Produits biodégradables", "Finitions durables"],
  },
  {
    slug: "isolation",
    title: "Isolation thermique",
    short: "Combles, murs, ITE",
    description:
      "Isolation par l'intérieur et l'extérieur, par des professionnels partenaires certifiés. Matériaux biosourcés disponibles, aides mobilisables.",
    features: ["Isolation par soufflage", "ITE certifiée", "Prime CEE incluse"],
  },
  {
    slug: "peinture",
    title: "Peinture & décoration",
    short: "Finitions premium",
    description:
      "Peinture intérieure et extérieure, papiers peints, enduits décoratifs, réalisés par nos peintres partenaires.",
    features: ["Peintures haut de gamme", "Préparation minutieuse", "Chantier propre"],
  },
  {
    slug: "plomberie",
    title: "Plomberie",
    short: "Sanitaires & chauffage",
    description:
      "Nos plombiers partenaires interviennent pour l'installation, la rénovation et le dépannage. Salle de bains, cuisine, réseaux, chauffe-eau.",
    features: ["Intervention rapide", "Devis transparent", "Marques reconnues"],
  },
  {
    slug: "electricite",
    title: "Électricité",
    short: "Mise aux normes NF C 15-100",
    description:
      "Rénovation complète du tableau électrique, création de circuits, éclairage, domotique — par des électriciens partenaires qualifiés.",
    features: ["Consuel garanti", "Domotique KNX", "Bornes de recharge VE"],
  },
  {
    slug: "poele-granules",
    title: "Poêle à granulés",
    short: "Chauffage bois & pellets",
    description:
      "Installation de poêles à granulés et à bois par nos professionnels partenaires certifiés Qualibois. Éligible aux aides de l'État.",
    features: ["Partenaires certifiés RGE Qualibois", "Aides MaPrimeRénov' & CEE", "Marques premium (MCZ, Rika, Palazzetti)"],
  },
  {
    slug: "surveillance",
    title: "Caméras de surveillance",
    short: "Vidéoprotection & alarme",
    description:
      "Systèmes de vidéosurveillance HD, alarme et interphonie connectés, installés par nos partenaires spécialisés en sécurité.",
    features: ["Caméras HD/4K jour & nuit", "Application mobile temps réel", "Conformité RGPD"],
  },
  {
    slug: "arrosage",
    title: "Arrosage automatique",
    short: "Jardin & pelouse",
    description:
      "Étude, pose et programmation de systèmes d'arrosage enterrés par nos paysagistes partenaires. Économies d'eau et jardin toujours impeccable.",
    features: ["Programmation intelligente", "Détection de pluie", "Économie d'eau 30-50%"],
  },
];

// ---------------------------------------------------------------------------
// RÉASSURANCE — bandeau de confiance (positionnement APPORTEUR D'AFFAIRES)
// ---------------------------------------------------------------------------
export const TRUST_ITEMS = [
  { value: "Sélectionnés", label: "Professionnels partenaires" },
  { value: "Réseau RGE", label: "Certifiés & qualifiés" },
  { value: "Gratuit", label: "Mise en relation & devis" },
  { value: "4.9/5", label: "Satisfaction clients Google" },
];

// ---------------------------------------------------------------------------
// GALERIE
// ---------------------------------------------------------------------------
export const GALLERY_CATEGORIES = [
  { key: "all", label: "Toutes les réalisations" },
  { key: "facade", label: "Façade" },
  { key: "toiture", label: "Toiture" },
  { key: "climatisation", label: "Climatisation" },
  { key: "poele", label: "Poêle à granulés" },
  { key: "interieur", label: "Rénovation intérieure" },
  { key: "exterieur", label: "Nettoyage des extérieurs" },
  { key: "surveillance", label: "Vidéosurveillance" },
  { key: "arrosage", label: "Arrosage automatique" },
];

export const GALLERY_ITEMS = [
  {
    id: "p-facade-01",
    category: "facade",
    title: "Ravalement de façade — enduit fin & volets restaurés",
    location: "Fondettes (37)",
    year: "2024",
    format: "combo",
    image:
      "https://customer-assets.emergentagent.com/job_penow-renovation/artifacts/snhgo5vf_ChatGPT%20Image%209%20juil.%202026%2C%2006_40_59.png",
    description:
      "Réalisation d'un professionnel partenaire : nettoyage complet, réfection de l'enduit, peinture minérale teinte crème et rénovation des menuiseries. Une seconde vie pour cette maison de bourg.",
  },
  {
    id: "p-toiture-01",
    category: "toiture",
    title: "Démoussage & hydrofuge coloré de toiture",
    location: "Indre-et-Loire (37)",
    year: "2024",
    format: "combo",
    image:
      "https://customer-assets.emergentagent.com/job_penow-renovation/artifacts/auokjadx_ChatGPT%20Image%209%20juil.%202026%2C%2006_46_08.png",
    description:
      "Réalisation d'un professionnel partenaire : traitement anti-mousse, nettoyage haute pression, application d'un hydrofuge coloré. Étanchéité restaurée et éclat des tuiles retrouvé.",
  },
  {
    id: "p-interieur-01",
    category: "interieur",
    title: "Rénovation complète de salle de bain",
    location: "Fondettes (37)",
    year: "2024",
    format: "combo",
    image:
      "https://customer-assets.emergentagent.com/job_penow-renovation/artifacts/vijp7thx_ChatGPT%20Image%209%20juil.%202026%2C%2006_42_33.png",
    description:
      "Réalisation d'un professionnel partenaire : dépose totale, plomberie neuve, faïence grand format, meuble vasque suspendu, miroir rétroéclairé et paroi de douche. Un espace apaisant, moderne et fonctionnel.",
  },
  {
    id: "p-clim-01",
    category: "climatisation",
    title: "Climatisation gainable — pièce de vie",
    location: "Villa contemporaine — Indre-et-Loire",
    year: "2024",
    format: "single",
    image:
      "https://customer-assets.emergentagent.com/job_penow-renovation/artifacts/alkkqvg7_ChatGPT%20Image%209%20juil.%202026%2C%2006_48_48.png",
    description:
      "Réalisation d'un professionnel partenaire : installation d'une climatisation réversible gainable, diffusion discrète par plénum plafond. Confort homogène, silence total, esthétique préservée.",
  },
  {
    id: "p-clim-02",
    category: "climatisation",
    title: "Climatisation split — chambre parentale",
    location: "Fondettes (37)",
    year: "2024",
    format: "single",
    image:
      "https://customer-assets.emergentagent.com/job_penow-renovation/artifacts/pg1kb6zy_ChatGPT%20Image%209%20juil.%202026%2C%2007_24_13.png",
    description:
      "Réalisation d'un professionnel partenaire : pose d'un split mural réversible dernière génération. Chauffage doux en hiver, fraîcheur en été, faible consommation et niveau sonore optimisé.",
  },
  {
    id: "p-arrosage-01",
    category: "arrosage",
    title: "Arrosage automatique enterré — pelouse & massifs",
    location: "Villa privée — Indre-et-Loire",
    year: "2024",
    format: "single",
    image:
      "https://customer-assets.emergentagent.com/job_penow-renovation/artifacts/8bqdiuyu_ChatGPT%20Image%209%20juil.%202026%2C%2008_14_52.png",
    description:
      "Réalisation d'un professionnel partenaire : installation d'un réseau d'arrosage automatique enterré avec turbines pour la pelouse, tuyères pour les massifs, programmateur connecté avec sonde d'humidité. Économie d'eau jusqu'à 50%.",
  },
  {
    id: "p-surveillance-01",
    category: "surveillance",
    title: "Vidéosurveillance — maison contemporaine",
    location: "Fondettes (37)",
    year: "2024",
    format: "single",
    image:
      "https://customer-assets.emergentagent.com/job_penow-renovation/artifacts/lb88b3cr_ChatGPT%20Image%209%20juil.%202026%2C%2008_16_09.png",
    description:
      "Réalisation d'un professionnel partenaire : pose de 4 caméras HD avec vision nocturne infrarouge couvrant l'entrée, le garage et les accès latéraux. Enregistrement NVR local, application mobile temps réel, conformité RGPD.",
  },
  {
    id: "p-surveillance-02",
    category: "surveillance",
    title: "Caméra dôme extérieure — pavillon plain-pied",
    location: "Indre-et-Loire (37)",
    year: "2024",
    format: "single",
    image:
      "https://customer-assets.emergentagent.com/job_penow-renovation/artifacts/yoo6np7m_ChatGPT%20Image%209%20juil.%202026%2C%2008_17_17.png",
    description:
      "Réalisation d'un professionnel partenaire : installation discrète d'une caméra dôme motorisée. Détection de mouvement intelligente, notifications instantanées, résistance IP66.",
  },
  {
    id: "p-poele-01",
    category: "poele",
    title: "Installation d'un poêle à granulés",
    location: "Fondettes (37)",
    year: "2025",
    format: "single",
    image:
      "https://customer-assets.emergentagent.com/job_penow-renovation/artifacts/l8i23k6p_IMG_1363.PNG",
    description:
      "Réalisation d'un professionnel partenaire : pose d'un poêle à granulés (pellets) design en angle, avec conduit d'évacuation et raccordement. Chauffage économique et écologique, éligible aux aides MaPrimeRénov' et CEE.",
  },
  {
    id: "p-interieur-02",
    category: "interieur",
    title: "Rénovation complète de cuisine — meubles noirs & crédence métro",
    location: "Indre-et-Loire (37)",
    year: "2025",
    format: "combo",
    image:
      "https://customer-assets.emergentagent.com/job_penow-renovation/artifacts/td17h9zw_penow-avant-apres-cuisine.png",
    description:
      "Réalisation d'un professionnel partenaire : transformation totale d'une cuisine — meubles hauts noirs vitrés, crédence carreaux métro et carreaux de ciment, plan de travail bois massif, évier grès blanc.",
  },
  {
    id: "p-exterieur-01",
    category: "exterieur",
    title: "Nettoyage extérieur — cour & allée pavée",
    location: "Villa privée — Indre-et-Loire",
    year: "2024",
    format: "combo",
    image:
      "https://customer-assets.emergentagent.com/job_penow-renovation/artifacts/tbqjmfhv_penow-avant-apres%20%281%29.png",
    description:
      "Réalisation d'un professionnel partenaire : remise en état complète des espaces extérieurs, nettoyage haute pression des pavés, désherbage, débroussaillage, remise en propre des allées et abords.",
  },
  {
    id: "p-exterieur-02",
    category: "exterieur",
    title: "Nettoyage & entretien de jardin — pelouse et abords",
    location: "Villa privée — Indre-et-Loire",
    year: "2024",
    format: "combo",
    image:
      "https://customer-assets.emergentagent.com/job_penow-renovation/artifacts/w7zvn0ib_penow-avant-apres-jardin-piscine2.png",
    description:
      "Réalisation d'un professionnel partenaire : débroussaillage complet, évacuation des déchets verts, nivellement du terrain et remise en état de la pelouse.",
  },
];

// ---------------------------------------------------------------------------
// TÉMOIGNAGES CLIENTS — parlent tous du service d'INTERMÉDIATION
// ---------------------------------------------------------------------------
export const TESTIMONIALS = [
  {
    id: "t1",
    name: "Sophie L.",
    role: "Cliente — Rénovation complète",
    rating: 5,
    text:
      "PENOW nous a mis en relation avec un professionnel irréprochable. Suivi de qualité, respect des délais, finitions parfaites. Merci pour l'accompagnement !",
  },
  {
    id: "t2",
    name: "Marc D.",
    role: "Copropriété — Ravalement",
    rating: 5,
    text:
      "Grâce à PENOW, nous avons trouvé le bon façadier pour notre immeuble. Sérieux, professionnalisme et résultat au rendez-vous.",
  },
  {
    id: "t3",
    name: "Isabelle et Julien P.",
    role: "Particuliers — PAC + isolation",
    rating: 5,
    text:
      "PENOW nous a accompagnés du diagnostic aux aides de l'État et nous a présenté le bon professionnel. Facture divisée par deux, confort inégalé.",
  },
  {
    id: "t4",
    name: "Restaurant Le Petit Marché",
    role: "Client professionnel — Climatisation",
    rating: 5,
    text:
      "Trouver le bon installateur de clim' en pleine saison n'a pas été un souci grâce à PENOW. Chantier propre, rapide et discret assuré par le professionnel partenaire.",
  },
  {
    id: "t5",
    name: "François B.",
    role: "Propriétaire — Toiture",
    rating: 5,
    text:
      "Un devis clair, un couvreur sérieux pour le démoussage et le remplacement des tuiles. Merci PENOW pour la mise en relation.",
  },
  {
    id: "t6",
    name: "Nathalie R.",
    role: "Propriétaire — Peinture intérieure",
    rating: 5,
    text:
      "Je cherchais un peintre fiable pour rénover mon intérieur. PENOW m'a trouvé la perle rare. Rendu impeccable !",
  },
];

// ---------------------------------------------------------------------------
// VALEURS
// ---------------------------------------------------------------------------
export const VALUES = [
  {
    key: "reseau",
    title: "Un réseau qualifié",
    description:
      "Chaque professionnel partenaire est sélectionné selon des critères stricts : qualifications, avis clients, expérience et engagement qualité.",
  },
  {
    key: "transparence",
    title: "Transparence totale",
    description:
      "Un seul interlocuteur pour vous, un devis clair remis directement par le professionnel partenaire, sans engagement.",
  },
  {
    key: "local",
    title: "Ancrage local",
    description:
      "Nous privilégions les professionnels implantés en Indre-et-Loire, pour un service de proximité et une meilleure réactivité.",
  },
  {
    key: "reactivite",
    title: "Réactivité",
    description:
      "Un devis sous 48h grâce à notre réseau. Vous économisez des heures de recherche et de comparaison.",
  },
];

// ---------------------------------------------------------------------------
// PROFESSIONNELS PARTENAIRES — anciennement "CERTIFICATIONS"
// ---------------------------------------------------------------------------
export const CERTIFICATIONS = [
  "Professionnels partenaires certifiés RGE QualiPAC",
  "Professionnels partenaires certifiés RGE Qualibois",
  "Professionnels partenaires certifiés RGE Qualibat",
  "Marques premium : LG · Daikin · Mitsubishi · MCZ · Rika",
  "Attestation Consuel remise par le partenaire électricien",
];

export const PROJECT_TYPES = [
  "Rénovation générale",
  "Climatisation / PAC",
  "Poêle à granulés",
  "Façade",
  "Toiture",
  "Isolation",
  "Peinture",
  "Plomberie",
  "Électricité",
  "Caméras de surveillance",
  "Arrosage automatique",
  "Nettoyage des extérieurs",
  "Autre",
];
